var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 30,
    viewBox: "0 0 48 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4355 0H0V32H18.4355H48.001V0H18.4355Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 6.74414L26.1249 13.2831H33.0004L27.4379 17.3243L29.5627 23.8634L24.0002 19.8221L18.4377 23.8634L20.5625 17.3243L15 13.2831H21.8755L24.0002 6.74414Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.842 10.6667H0V0.842142C0 0.377094 0.377094 0 0.842143 0H47.9999C48.465 0 48.8421 0.377094 48.8421 0.842142L48.842 10.6667Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9998 32.0005H0.842143C0.377094 32.0005 0 31.6234 0 31.1583V21.3339H48.842V31.1583C48.842 31.6235 48.4649 32.0005 47.9998 32.0005Z",
    fill: "#73AF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.842 10.6663H0V21.3323H48.842V10.6663Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4208 20.5262C21.9249 20.5262 19.8945 18.4958 19.8945 15.9999C19.8945 13.504 21.9249 11.4736 24.4208 11.4736C26.9167 11.4736 28.9471 13.504 28.9471 15.9999C28.9471 18.4958 26.9167 20.5262 24.4208 20.5262ZM24.4208 12.3157C22.3891 12.3157 20.7366 13.9682 20.7366 15.9999C20.7366 18.0316 22.3891 19.6841 24.4208 19.6841C26.4525 19.6841 28.105 18.0316 28.105 15.9999C28.105 13.9682 26.4525 12.3157 24.4208 12.3157Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4213 16.5136C24.7047 16.5136 24.9345 16.2838 24.9345 16.0004C24.9345 15.717 24.7047 15.4873 24.4213 15.4873C24.1379 15.4873 23.9082 15.717 23.9082 16.0004C23.9082 16.2838 24.1379 16.5136 24.4213 16.5136Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4216 16.077L23.1176 16.2086L20.3164 16.077V15.923L23.1176 15.7914L24.4216 15.923V16.077Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4219 16.077L25.7259 16.2086L28.5271 16.077V15.923L25.7259 15.7914L24.4219 15.923V16.077Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3445 16.001L24.2129 14.6969L24.3445 11.8958H24.4985L24.6302 14.6969L24.4985 16.001H24.3445Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3445 16.0001L24.2129 17.3042L24.3445 20.1053H24.4985L24.6302 17.3042L24.4985 16.0001H24.3445Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3657 16.0545L23.3506 15.2256L21.4629 13.1517L21.5717 13.0428L23.6456 14.9305L24.4745 15.9457L24.3657 16.0545Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3672 16.0539L25.1961 17.0691L27.2699 18.9568L27.3788 18.8479L25.4911 16.7741L24.4759 15.9452L24.3672 16.0539Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3672 15.9457L25.1961 14.9305L27.2699 13.0428L27.3788 13.1517L25.4911 15.2256L24.4759 16.0545L24.3672 15.9457Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3657 15.9452L23.3506 16.7741L21.4629 18.8479L21.5717 18.9568L23.6456 17.0691L24.4745 16.0539L24.3657 15.9452Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4513 16.072L23.2968 16.6927L20.6586 17.643L20.5996 17.5007L23.1372 16.3072L24.3923 15.9297L24.4513 16.072Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4515 16.0713L25.7066 15.6938L28.2442 14.5003L28.1853 14.358L25.547 15.3084L24.3926 15.929L24.4515 16.0713Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3503 16.03L23.7296 14.8755L22.7793 12.2373L22.9215 12.1783L24.1151 14.7159L24.4926 15.971L24.3503 16.03Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3496 16.0304L24.7271 17.2855L25.9207 19.8231L26.0629 19.7641L25.1126 17.1259L24.4919 15.9714L24.3496 16.0304Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3923 16.0713L23.1372 15.6938L20.5996 14.5003L20.6586 14.358L23.2968 15.3084L24.4513 15.929L24.3923 16.0713Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3926 16.072L25.547 16.6927L28.1853 17.643L28.2442 17.5007L25.7066 16.3072L24.4515 15.9297L24.3926 16.072Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3496 15.971L24.7271 14.7159L25.9207 12.1783L26.0629 12.2373L25.1126 14.8755L24.4919 16.03L24.3496 15.971Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3503 15.9714L23.7296 17.1259L22.7793 19.7641L22.9215 19.8231L24.1151 17.2855L24.4926 16.0304L24.3503 15.9714Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4207 16.6928C24.803 16.6928 25.1129 16.3829 25.1129 16.0007C25.1129 15.6184 24.803 15.3085 24.4207 15.3085C24.0384 15.3085 23.7285 15.6184 23.7285 16.0007C23.7285 16.3829 24.0384 16.6928 24.4207 16.6928Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4209 16.4152C24.6502 16.4152 24.836 16.2294 24.836 16.0001C24.836 15.7709 24.6502 15.5851 24.4209 15.5851C24.1917 15.5851 24.0059 15.7709 24.0059 16.0001C24.0059 16.2294 24.1917 16.4152 24.4209 16.4152Z",
    fill: "#41479B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 31.48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndia);
export default __webpack_public_path__ + "static/media/India.445174c5b93f7a622d888438b9d46b99.svg";
export { ForwardRef as ReactComponent };